import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { ClientService } from '@app/core/client/services/client.service';
import { RFQ } from '@app/core/quotes';

@Component({
  selector: 'cnc-rfq-client-profile',
  templateUrl: './rfq-client-profile.component.html',
  styleUrls: ['./rfq-client-profile.component.scss'],
})
export class RfqClientProfileComponent implements OnInit {
  pageTitle :string = this.translate.instant('TITLES.CLIENT_PROFILE');
  businessAcc :any = {};
  @Input() rfq :RFQ;

  constructor(
    private clientService :ClientService,
    private translate :TranslateService,
    public activeModal :NgbActiveModal,
  ) {}

  ngOnInit() {
    this.clientService
      .getById(this.rfq.business_account_id)
      .subscribe((business_account :any) => {
        this.businessAcc = business_account;
      });
  }
}
